module.exports = __webpack_public_path__ + "img/mongodb.7f37b5fa.png";